import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Tab} from "../../core/interfaces/tab";

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

  @Input() tabList: Tab[] = [];
  @Input() selectedTab: string = '';

  @Output() tabChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  isTabSelected(currentTab): boolean {
    return this.selectedTab === currentTab;
  }

  selectTab(value: string): void {
    this.selectedTab = value;
    this.tabChange.emit(value);
  }

}
